/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Delete_ConfirmInputs */

const cs_documents_delete_confirm = /** @type {(inputs: Documents_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout položku do koše?`)
};

const en_documents_delete_confirm = /** @type {(inputs: Documents_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move this item to trash?`)
};

/**
* | output |
* | --- |
* | "Move this item to trash?" |
*
* @param {Documents_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_delete_confirm = /** @type {((inputs?: Documents_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_delete_confirm(inputs)
	return cs_documents_delete_confirm(inputs)
});